import { render, staticRenderFns } from "./companyadd.vue?vue&type=template&id=2c55ff4b"
import script from "./companyadd.vue?vue&type=script&lang=js"
export * from "./companyadd.vue?vue&type=script&lang=js"
import style0 from "./companyadd.vue?vue&type=style&index=0&id=2c55ff4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports